export function getMinMaxCordinates(bounds) {
  const { nw, se, ne, sw } = bounds || { nw: {}, se: {}, ne: {}, sw: {} };
  const start_lat = Math.min(ne.lat, sw.lat, se.lat, nw.lat);
  const end_lat = Math.max(ne.lat, sw.lat, se.lat, nw.lat);
  const start_lon = Math.min(ne.lng, sw.lng, se.lng, nw.lng);
  const end_lon = Math.max(ne.lng, sw.lng, se.lng, nw.lng);

  return {
    start_lat,
    end_lat,
    start_lon,
    end_lon
  };
}
